import React, { useContext } from "react";
import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";


const Filters:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {filterPanelShown, toggleFilterPanelState} = rootStore.filterPanelStore;
  const {addChosenSubject, removeChosenSubject, allSubjectsByType, chosenSubjects} = rootStore.subjectStore;
  const {addChosenYear, removeChosenYear, allYearsByType, chosenYears} = rootStore.yearsStore;

  const toggleSubject = (clickedSubject) => {
    if(chosenSubjects.find(x => x.slug === clickedSubject.slug)) {
      // Remove
      removeChosenSubject(clickedSubject);
    } else {
      addChosenSubject(clickedSubject);
    }
  }

  const toggleYear = (clickedYear) => {
    if(chosenYears.find(x => x.slug === clickedYear.slug)) {
      // Remove
      removeChosenYear(clickedYear);
    } else {
      addChosenYear(clickedYear);
    }
  }  

  return (
    <div className='filters__holder'>
      <div className={`filters ` + (filterPanelShown ? 'shown' : '')}>
        <div className='filters__inner'>
          <p className='filters__title'>Select subjects...</p>
          <div className='filters__groups buttons filters__groups_subjects'>
            {allSubjectsByType && allSubjectsByType.sort((a, b) => {return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })}).map(subject => 
              <button key={subject.slug} onClick={() => toggleSubject(subject)}
                className={chosenSubjects.find(chosenSubject => chosenSubject.slug === subject.slug) ? 'chosen' : ''}
              >{subject.name}</button>
            )}
          </div>

          <p className='filters__title filters__title-years'>Select years...</p>
          <div className='filters__groups filters__groups_years'>
            {allYearsByType && allYearsByType.map(year => 
              <button key={year.slug} onClick={() => toggleYear(year)}
                className={chosenYears.find(chosenYear => chosenYear.slug === year.slug) ? 'year chosen' : 'year'}
              >{year.name}</button>
            )}
          </div>
        </div>

        {chosenSubjects.length === 0 && chosenYears.length === 0 &&
          <button className='filters__hide-filters' onClick={() => toggleFilterPanelState()}>Hide filters</button>
        }
        {(chosenSubjects.length !== 0 || chosenYears.length !== 0) &&
          <button className='filters__hide-filters show-results' onClick={() => toggleFilterPanelState()}>Show results</button>
        }        
        
      </div>
    </div>
  )
});

export default Filters;